// extracted by mini-css-extract-plugin
export default {"label":"label__WVHp7","left":"left__mWkcs","center":"center__kkYL2","right":"right__AVfxr","hidden":"hidden__Pk5yl"};